const vars = {
	breakpoint: {
		mobile: 360,
		tabletSmall: 600,
		tablet: 768,
		laptopSmall: 1024,
		laptop: 1280,
		desktop: 1600,
		largest: 1920,
	},
};

export { vars };
